export const constructionSiteApiActionTypes = {
  resetConstructionSites: 'RESET_CONSTRUCTION_SITES',

  readConstructionSitesRequest: 'READ_CONSTRUCTION_SITES_REQUEST',
  readConstructionSitesSuccess: 'READ_CONSTRUCTION_SITES_SUCCESS',
  readConstructionSitesFailure: 'READ_CONSTRUCTION_SITES_FAILURE',
}
